module.exports = __webpack_public_path__ + "cc2fadc3928f2f223418887111947b40.woff";